import React,{useMemo} from "react";
import styles from '../Styles/Itinerary.module.css';

export default function TAndC(){

const data = useMemo(() => [
  'Cancellations are permitted only if requested at least 15 days prior to the scheduled departure date.',
  'All booking rates are subject to change without prior notice.',
  'In the event of unavailability at listed hotels, comparable alternative accommodations will be provided.',
  'If a package is canceled due to natural disasters or adverse weather conditions, Shivira will endeavor to process the maximum refund possible, subject to applicable policies.',
  'Shivira reserves the right to modify the itinerary due to unforeseen circumstances, including but not limited to strikes, festivals, traffic disruptions, or entry restrictions. While every effort will be made to provide suitable alternatives, Shivira is not liable for claims, refunds, or compensation arising from such changes.',
  'Certain hotels may require a refundable security deposit upon check-in, as per their policies.',
  'The package price excludes personal expenses, including but not limited to laundry, telephone calls, room service, alcoholic beverages, mini-bar charges, gratuities, porterage, and camera fees.',
  'Costs associated with travel deviations or extensions of ticket validity are not included in the package price.'
], []);


    return(
        <div className={styles.tacContainer}>
            <ul className={styles.list}>
                {data.map((text, index)=>{
                    return <li key={index} className={styles.listItem}>{text}</li>
                })}
            </ul>
        </div>
    )
}